export type AppToastVariant = 'success' | 'error'

export type AppToastPayload = {
  id: number
  message: string
  variant: AppToastVariant
}

type AppToastListener = (toast: AppToastPayload | null) => void

const listeners = new Set<AppToastListener>()
let nextToastId = 0

export function subscribeAppToast(listener: AppToastListener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function publishAppToast(message: string, variant: AppToastVariant): AppToastPayload {
  const toast: AppToastPayload = {
    id: ++nextToastId,
    message,
    variant,
  }
  listeners.forEach((listener) => listener(toast))
  return toast
}

export function clearAppToast(): void {
  listeners.forEach((listener) => listener(null))
}
